import React from 'react';

import { submit } from '../../../AppServices';
import { Form } from '../../../app-components/form/Form';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import {
  MODELS,
  ROUTES,
  selectDMS,
  selectVMPP,
  selectKycStatus,
} from '../../../Lib/constants';
import { validateAdminMobile, validateEmail } from '../../../Lib/helpers';
import { EditDealerKycURI } from '../../../Queries/dealer';

const validations = {
  email: ({ data }) => validateEmail(data?.email),
  phonenumber: ({ data }) => validateAdminMobile(data?.phonenumber),
};

const ViewDealerKyc = (props) => (
  <Form
    type="standard"
    uri={EditDealerKycURI}
    closeView={1}
    reloadEvent={ROUTES.dealerData.name}
    reloadOnChangeEvent={ROUTES.dealerData.name}
    onSubmit={submit({
      model: MODELS.Dealer,
    })}
    validations={validations}
    mandatory={{ username: 1, email: 1, phonenumber: 1 }}
    submitMessage="Dealer Kyc Updated Successfully"
    uniqueValidationMessage="Username already exist."
    fieldContainer="topLabel"
    lg={{
      formGroups: [
        {
          columnsPerRow: 2,
          fieldVariant: 'filled',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'name',
                  label: 'Dealership Name',
                  mandatory: true,
                  allowWhiteSpaces: true,
                  editable: false,
                },
                {
                  type: 'text',
                  field: 'username',
                  label: 'Username',
                  mandatory: true,
                  allowWhiteSpaces: true,
                  editable: false,
                },
                {
                  type: 'text',
                  field: 'phonenumber',
                  label: 'Mobile Number',
                  modifyValueOnChange: ({ prevValue, value }) => {
                    if (value?.toString()?.length > 10) {
                      return prevValue;
                    }
                    return value;
                  },
                  editable: false,
                },
                {
                  type: 'text',
                  field: 'email',
                  label: 'Email Id',
                  mandatory: true,
                  allowWhiteSpaces: false,
                  editable: false,
                },
                autoSuggestOptionsInput({
                  label: 'DMS',
                  field: 'dms',
                  suggestionField: 'label',
                  valueField: 'label',
                  options: selectDMS,
                  keyField: 'value',
                  editable: false,
                }),
                autoSuggestOptionsInput({
                  label: 'VMPP',
                  field: 'vmpp',
                  suggestionField: 'label',
                  valueField: 'label',
                  options: selectVMPP,
                  keyField: 'label',
                  editable: false,
                }),
                autoSuggestOptionsInput({
                  label: 'KYC Status',
                  field: 'kycStatus',
                  suggestionField: 'label',
                  valueField: 'label',
                  options: selectKycStatus,
                  keyField: 'label',
                  editable: false,
                }),
              ],
            },
          ],
        },
      ],
    }}
    {...props}
  />
);

export default ViewDealerKyc;
